import { Link } from "react-router-dom";
import { ArrowUpRight, ShieldCheck, Workflow } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/shared";
import { TemplatesTab } from "@/components/settings/TemplatesTab";
import { QuoteTemplateTab } from "@/components/settings/QuoteTemplateTab";
import { IntegrationsTab } from "@/components/settings/IntegrationsTab";

export default function Settings() {
  return (
    <div>
      <PageHeader title="Settings" subtitle="Customer notifications, the quotation template and integrations. Margins & gift tiers live under Quotations.">
        <Link to="/settings/workflows" className="inline-flex items-center gap-1.5 text-sm rounded-md border px-3 py-1.5 hover:bg-secondary/50" data-testid="settings-link-workflows"><Workflow className="h-4 w-4" />Workflows<ArrowUpRight className="h-3 w-3" /></Link>
        <Link to="/settings/users" className="inline-flex items-center gap-1.5 text-sm rounded-md border px-3 py-1.5 hover:bg-secondary/50" data-testid="settings-link-roles"><ShieldCheck className="h-4 w-4" />Role Manager<ArrowUpRight className="h-3 w-3" /></Link>
      </PageHeader>
      <Tabs defaultValue="templates">
        <TabsList className="mb-5 flex-wrap h-auto">
          <TabsTrigger value="templates" data-testid="settings-tab-templates">Notification Templates</TabsTrigger>
          <TabsTrigger value="quote-template" data-testid="settings-tab-quote-template">Quotation Template</TabsTrigger>
          <TabsTrigger value="integrations" data-testid="settings-tab-integrations">Integrations</TabsTrigger>
        </TabsList>
        <TabsContent value="templates"><TemplatesTab /></TabsContent>
        <TabsContent value="quote-template"><QuoteTemplateTab /></TabsContent>
        <TabsContent value="integrations"><IntegrationsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
